import { PlayoffSeriesTeam } from './types';

//TODO refactor
export const getSeasonStringFromUrlYear = (year: string | undefined): string => {
    const numericalYear = Number(year);
    return numericalYear ? numericalYear - 1 + '' + numericalYear : 'invalid';
};

//TODO refactor
export const getSingleSeriesLetterFromUrlSeries = (series: string | undefined): string =>
    series?.split('-')?.[1] || 'invalid';

export const isSeriesComplete = (
    bottomSeedTeam: PlayoffSeriesTeam,
    topSeedTeam: PlayoffSeriesTeam,
    neededToWin: number
) => bottomSeedTeam.seriesWins === neededToWin || topSeedTeam.seriesWins === neededToWin;
